export default __webpack_public_path__ + "static/logotype-00ae1172f3427e759ff24d63a0ba9c7d.svg";